/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import { useRouter } from 'js/lib/useRouter';

import { Button } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { handleConsumerCTAClick } from 'bundles/front-page/utils';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/front-page';

const REDIRECT_URL = '/onboarding?src=banner,frontpage';
const HERO_POSITION = 250;

const AUTH_MODE = 'signup';

const animateIn = keyframes`
  0% { 
    opacity: 0;
    transform: translateY(200px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;

const styles = {
  container: css`
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(200px);
    background: var(--cds-color-neutral-background-primary);
    padding: var(--cds-spacing-200);
    box-shadow: 0 0 4px rgb(0 0 0 / 15%);
    display: block;
  `,
  slideIn: css`
    display: block;
    animation: 0.5s ease-in-out 1 normal forwards running ${animateIn};
  `,
  joinButton: css`
    width: 100%;
    max-width: unset;
  `,
};

const StickyEnrollButtonModule = () => {
  const [scrolledPastHero, setScrolledPastHero] = useState(false);
  const trackEvent = useTracker();
  const router = useRouter();

  const handleSignUpClick = () => {
    trackEvent('click_button', {
      button: { name: 'enroll' },
      pageSection: { sectionName: 'sticky_page_navigation' },
    });
    handleConsumerCTAClick(router, AUTH_MODE);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolledPast = window.scrollY >= HERO_POSITION;
      setScrolledPastHero(scrolledPast);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div css={[styles.container, scrolledPastHero ? styles.slideIn : undefined]}>
      <Button
        component={TrackedButton}
        requireFullyVisible={false}
        withVisibilityTracking={false}
        trackingName="sticky_enroll_button"
        data={{ copy: _t('Join for Free'), href: REDIRECT_URL }}
        onClick={handleSignUpClick}
        css={styles.joinButton}
        variant="primary"
        role="button"
      >
        {_t('Join for Free')}
      </Button>
    </div>
  );
};

export default StickyEnrollButtonModule;
